import React from "react";
import FreemiumFullScreenCarousel from "../components/FreemiumFullScreenCarousel";
import { connect } from "react-redux";

export class Featured extends React.Component {

  render() {
    const { featuredPlaylist } = this.props;
    return (
      <FreemiumFullScreenCarousel
        selectedArtwork={0}
        history={this.props.history}
        playlistName={featuredPlaylist.data.name}
        artworks={featuredPlaylist.data.artworks}
        hasSubscription = {
                            typeof this.props.subscription &&
                            this.props.subscription.data &&
                            this.props.subscription.data.plan &&
                            this.props.subscription.data.plan.id === 'string'
                          }
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  storeHistory: (history) => dispatch(storeHistory(history)),
});

export default connect(state => {
  const { featuredPlaylist, subscription } = state;
  return {
    featuredPlaylist,
    subscription,
  };
}, mapDispatchToProps)(Featured);
